
import PageLayout from "@/layouts/PageLayout";
import { BackgroundGradient } from "@/components/ui/background-gradient";

const VisionPage = () => {
  return (
    <PageLayout pageTitle="cheqbooq">
      <BackgroundGradient className="py-16 px-6 flex-grow" variant="subtle">
        <div className="max-w-3xl mx-auto">
          <h1 className="premium-title mb-8">Our Vision</h1>
          
          <div className="space-y-6">
            <p className="text-lg text-gray-700 dark:text-gray-300">
              We're creating a financial revolution that empowers individuals through data clarity and ownership.
            </p>
            
            <h2 className="text-2xl font-display font-medium mt-12 mb-4">A Financial System That Works For You</h2>
            <p>
              For too long, the financial system has operated on an imbalance of information. Financial 
              institutions collect enormous amounts of data about your financial life, but that data is rarely used 
              to benefit you directly.
            </p>
            <p>
              Our vision is to flip this dynamic. We believe that when you have clear insights about your financial 
              patterns, you can make better decisions, avoid pitfalls, and build a more secure future.
            </p>
            
            <h2 className="text-2xl font-display font-medium mt-12 mb-4">Beyond Traditional Finance</h2>
            <p>
              cheqbooq isn't simply a financial tool with a new interface. We're reimagining the entire relationship between 
              individuals and their money. This means creating tools that:
            </p>
            <ul className="space-y-2 my-4">
              <li className="text-gray-700 dark:text-gray-300">Visualize spending patterns in meaningful, actionable ways</li>
              <li className="text-gray-700 dark:text-gray-300">Identify opportunities for improved financial health</li>
              <li className="text-gray-700 dark:text-gray-300">Provide insights without judgment or hidden agendas</li>
              <li className="text-gray-700 dark:text-gray-300">Give you control over your financial future</li>
            </ul>
            
            <h2 className="text-2xl font-display font-medium mt-12 mb-4">Joining the Movement</h2>
            <p>
              We're building cheqbooq with a community-first approach. By pledging your support before our launch, 
              you're not just pre-ordering a product – you're joining a movement that believes financial data should 
              empower individuals, not exploit them.
            </p>
            <p>
              Your early support allows us to build a platform that truly represents this vision, independent from 
              the constraints and compromises that often come with traditional funding models.
            </p>
            
            <h2 className="text-2xl font-display font-medium mt-12 mb-4">Launch and Beyond</h2>
            <p>
              Our planned December 2025 launch is just the beginning. We envision cheqbooq leading a transformation in 
              how people interact with their finances – creating a new standard for transparency, insight, and user 
              empowerment that other financial institutions will eventually have to follow.
            </p>
            <p>
              Join us in creating this future – a future where your financial data works for you.
            </p>
          </div>
        </div>
      </BackgroundGradient>
    </PageLayout>
  );
};

export default VisionPage;
